export default "__VITE_ASSET__VIa0Drnk__"